import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PayrollPayment } from '~/types';
import styled from 'styled-components';
import theme from '~/theme';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';

interface ValidationStatusFieldProps {
  status: PayrollPayment['validationStatus'];
}

const ValidationStatusField: FC<ValidationStatusFieldProps> = (props) => {
  const { status } = props;
  const [t] = useTranslation('payrolls');

  if (status === 'OK')
    return (
      <StatusCellSuccess>
        <CheckCircleFilled /> {t('Ready to pay')}
      </StatusCellSuccess>
    );

  return (
    <StatusCellReject>
      <CloseCircleFilled /> {t('Unable to pay')}
    </StatusCellReject>
  );
};

const StatusCellSuccess = styled.span`
  color: ${theme.successColor};
`;

const StatusCellReject = styled.span`
  color: ${theme.errorColor};
`;

export default ValidationStatusField;
